"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shallowEquals_1 = require("./src/shallowEquals");
exports.shallowEquals = shallowEquals_1.shallowEquals;
var merge_1 = require("./src/merge");
exports.merge = merge_1.merge;
var shallowMerge_1 = require("./src/shallowMerge");
exports.shallowMerge = shallowMerge_1.shallowMerge;
var mergeDeep_1 = require("./src/mergeDeep");
exports.mergeDeep = mergeDeep_1.mergeDeep;
exports.shallowMergeDeep = mergeDeep_1.shallowMergeDeep;
var discard_1 = require("./src/discard");
exports.discard = discard_1.discard;
var pick_1 = require("./src/pick");
exports.pick = pick_1.pick;
var objectMap_1 = require("./src/objectMap");
exports.objectMap = objectMap_1.objectMap;
